import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Grid } from './../../../../themes/default';
import { EditIcon, CloseIcon } from './../../../../themes/icons';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../../components/includes/container';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar } from './../../../../components/includes/ui/table';
import { Loading } from './../../../../components/includes/loading';
import { ToolbarPrimary } from './../../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../../components/includes/breadcrumb';
import { Modal } from './../../../../components/includes/modal';
import { Btn, Label } from './../../../../components/includes/ui';
import { FormatDate } from './../../../../utilities/date';
import { isSorting, isStatus } from './../../../../utilities/utils';
import { PollService } from './../../../../services';
import Confirm from './../../../shared/confirm';

import BuilderConfig from './../config';

const rows = [
  { id: 'position', sort: true, numeric: false, disablePadding: false, label: 'Nro.', width: 40, minWidth: 40 },
  { id: 'text', sort: false, numeric: false, disablePadding: false, label: 'Pregunta', width: 350, minWidth: 350 },
  { id: 'status', sort: false, numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'type', sort: false, numeric: false, disablePadding: false, label: 'Tipo' },
  { id: 'reference', sort: false, numeric: false, disablePadding: false, label: 'Referencia' },
  { id: 'created_at', sort: false, numeric: false, disablePadding: false, label: 'Creado' },
  { id: 'updated_at', sort: false, numeric: false, disablePadding: false, label: 'Editado' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:160, minWidth: 160 }
];

class PollBuilder extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      id: null,
      loading: false,
      sending: false,
      poll: null,
      questions: null,
      questionId: null,
      questionType: null,
      order: 'asc',
      orderBy: 'name',
      builderConfigShow: false,
      formDeleteShow: false,
      formDeleteMessage: null
    };
  }

  componentDidMount(){

    this._Find();

  }

  /*
  ** @Service
  ** @Description: Find Poll
  */

  _Find = () => {

    let id = this.props.match.params.id;

    PollService.find(id).then((response) => {

      // @State
      this.setState({ id: id, poll: response.poll });

      // @Service find all questions
      this._Questions(id);

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Find Questions
  */

  _Questions = (id) => {

    PollService.questions(id).then((response) => {

      // @State
      this.setState({ loading: true, questions: response.questions });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error });

    });

  }

  /*
  ** @Service
  ** @Description: Delete
  */

  _Delete = (id) => {

    PollService.removeQuestion(id).then((response) => {

      // @State
      this.setState({ formDeleteShow: false });

      // @Service find all questions
      this._Questions(this.state.id);

      // @Dispatch alert success
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el pregunta fue eliminada.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Event
  ** @Description: On save success
  */

  handleOnSuccess = () => {

    // @Description: close modal
    this.setState({ builderConfigShow: false });

    // @Description: find all questions
    this._Find();

    // @Dispatch alert success
    this.props.AlertShow({ open: true, variant: 'success', message: `Exito, la pregunta fue creada.` });

  }

  /*
  ** @Event
  ** @Description: Close builder question
  */

  handleCancelBuilderConfig = (status) => {
    this.setState({ builderConfigShow: status });
  }

  /*
  ** @Event
  ** @Description: Update question
  */

  handleUpdate = (id, type) => {

    this.handleCancelBuilderConfig(true);

  }

  /*
  ** @Event
  ** @Description: Delete question
  */

  handleDelete = (id) => {
    this.setState({
      questionId: id,
      formDeleteShow: true,
      formDeleteMessage: `¿Confirma la eliminación?`
    });
  }

  /*
  ** @Click
  ** @Description: Cancel delete question
  */

  handleConfirmDeleteCancel = () => {
    this.setState({ formDeleteShow: false });
  }

  /*
  ** @Click
  ** @Description: Delete question
  */

  handleConfirmDeleteConfirm = () => {
    this._Delete(this.state.questionId);
  }

  render() {

    const { poll, loading, questions, order, orderBy, builderConfigShow } = this.state;

    return (
      <Section>
        <ToolbarPrimary title="Encuestas"/>
        <BreadcrumbItem to='/polls'>Encuestas</BreadcrumbItem>
        <BreadcrumbItem to='/polls/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            { loading ? (

              <React.Fragment>

                <Ttolbar title={ poll.name }>
                  <Buttons>
                    <Btn color="success" aria-label="add" icon="add" onClick={ () => { this.handleCancelBuilderConfig(true) } }>
                      Crear pregunta
                    </Btn>
                  </Buttons>
                </Ttolbar>

                {/* Builder */}
                <Modal
                    status={ builderConfigShow }
                    title="&nbsp;"
                    handleCancel={ () => { this.handleCancelBuilderConfig(false) } }
                    maxWidth="md">
                    <BuilderConfig
                      onSuccess={ this.handleOnSuccess }
                    />
                </Modal>

                {/* Delete */}
                <Confirm
                   status={ this.state.formDeleteShow }
                   message={ this.state.formDeleteMessage }
                   cancel={ () => { this.handleConfirmDeleteCancel() } }
                   confirm={ () => { this.handleConfirmDeleteConfirm() } }
                />

                <FormContent enabledActions disabledGuttersSide disabledGutterTop>

                  <Tresponsive>
                    <Table>

                      <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>

                      <Tbody>

                        { questions.length > 0 ? (

                          questions.sort(isSorting(order, orderBy)).map(entity => {
                            return (
                              <Row key={ entity._id }>
                                <Cell>
                                  { entity.position }
                                </Cell>
                                <Cell>
                                  <span dangerouslySetInnerHTML={{ __html: entity.text }}/>
                                </Cell>
                                <Cell>
                                  <Label variant={ entity.status ? "success" : "danger"}>
                                    { isStatus(entity.status) }
                                  </Label>
                                </Cell>
                                <Cell>
                                  <Label variant="info">
                                    { entity.type }
                                  </Label>
                                </Cell>
                                <Cell>
                                  <Label variant="secondary">
                                    { entity.reference }
                                  </Label>
                                </Cell>
                                <Cell>
                                  <FormatDate value={ entity.created_at }/>
                                </Cell>
                                <Cell>
                                  <FormatDate value={ entity.updated_at }/>
                                </Cell>
                                <Cell numeric>
                                  <Btn color="primary" size="xsmall" onClick={ () => { this.handleUpdate(entity._id, entity.type) } }>
                                    <EditIcon fontSize="small"/>
                                  </Btn>
                                  <Btn color="danger" size="xsmall" onClick={ () => { this.handleDelete(entity._id) } }>
                                    <CloseIcon fontSize="small"/>
                                  </Btn>
                                </Cell>
                              </Row>
                            );
                          })

                        ) : (

                          <Row key="1">
                            <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                          </Row>

                        )}

                      </Tbody>

                    </Table>
                  </Tresponsive>

                </FormContent>

                <FormActions>
                  <Grid container>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                      <Buttons>
                        <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/polls">
                          Volver
                        </Btn>
                      </Buttons>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                    </Grid>
                  </Grid>
                </FormActions>

              </React.Fragment>

            ) : (
              <Loading variant="primary"/>
            )}

          </Main>

        </Content>
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PollBuilder);
